module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAMAAADTXB33AAAAVFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////8wXzyWAAAAG3RSTlMABurdLeK89OjWZzMhDvCyXlzLtKiOKBQBwKpHAPLbAAAAmElEQVQoz3XO2xKDIAxF0RNBFATvtzb//5+lWkerZD0xsyckiMiZmsuhI4C6oeTaOMKmUryzWlveqWorBR+KyzM2UpykCI4FDkZKL9RSKsEi5PJUI6UGrZRakPBjTkAnDUXv9KavoJ5FBWx8di+Zx4/ObkUDZxNKNOeXs2f88fYo1uNm6ffSL3gIhiMTkEAj80hIWqdpxekDMUgrt2W3U3wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/love.png
// module id = JJUA
// module chunks = 1